import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Hero from '../../components/Hero/Hero';
import Categories from '../../components/Categories/Categories';
import BestSeller from '../../components/BestSeller/BestSeller';
import ShopTheLook from '../../components/ShopTheLook/ShopTheLook';
import Testimonials from '../../components/Testimonials/Testimonials';
import GetTheLook from '../../components/GetTheLook/GetTheLook';
import Features from '../../components/Features/Features';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Categories />
      <BestSeller />
      <ShopTheLook />
      <Testimonials />
      <GetTheLook />
      <Features />
      <Footer />
    </div>
  );
};

export default Home;
